var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.334 27.913a13.333 13.333 0 10-15.385 13.262v-9.231h-3.416v-4.031h3.416v-3.559a4.564 4.564 0 014.43-4.472c1.157-.06 2.316.037 3.447.287v3.252H31.63a1.682 1.682 0 00-1.662 1.743v2.749h3.754l-.595 4.03H29.97v9.232a13.385 13.385 0 0011.365-13.262z",
    fill: "#fff"
  })));
}
export default SvgFacebook;